import styled from "styled-components";
import { P } from './Dangerously';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import FbIcon from "../../assets/images/layout/logos/fb.svg";
import LnIcon from "../../assets/images/layout/logos/linkedin.svg";
import XIcon from "../../assets/images/layout/logos/x.svg";
import WAIcon from "../../assets/images/layout/logos/whatsapp-inv.svg";

const ShareRouter = ({
  children,
  shareUrl,
}: {
  children?: React.ReactNode;
  shareUrl: string;
}) => {
  return (
    <LogoList $noText={!children}>
      {children && <P>{children + " "}</P>}
      <LinkedinShareButton url={shareUrl} aria-label="LinkedIn">
        <Icon>
          <LnIcon />
        </Icon>
      </LinkedinShareButton>
      <TwitterShareButton url={shareUrl} aria-label="X">
        <Icon>
          <XIcon />
        </Icon>
      </TwitterShareButton>
      <FacebookShareButton url={shareUrl} aria-label="Facebook">
        <Icon>
          <FbIcon />
        </Icon>
      </FacebookShareButton>
      <WhatsappShareButton url={shareUrl} aria-label="WhatsApp">
        <Icon>
          <WAIcon />
        </Icon>
      </WhatsappShareButton>
    </LogoList>
  );
};

export default ShareRouter;

const Icon = styled.div`
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      svg {
        transform: scale(1.1);
      }
    }
  }
  svg {
    width: 32px;
    height: 32px;
    transition: transform 0.2s ease-out;
    path {
      fill: ${(p) => p.theme.colors.foreground};
      transition: fill 0.3s ease-in;
    }
  }
`;

const LogoList = styled.div<{ $noText?: boolean }>`
  display: inline-flex;
  align-items: center;
  margin-top: 15px;
  padding: 16px 20px 15px;
  border: 2px solid ${(p) => p.theme.colors.foreground_low};
  border-radius: 300px;
  gap: 15px;
  p {
    display: none;
    padding: 0 !important;
    margin: -5px 6px 0 12px;
  }
  a {
    display: flex;
    cursor: pointer;
    svg {
      box-shadow: none;
    }
    &:active,
    &:focus {
      outline: none;
      svg {
        transform: scale(0.9);
      }
    }
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        svg {
          transform: scale(1.1);
        }
      }
    }
  }
  @media (min-width: 430.01px) {
    margin-top: 2rem;
    padding-left: ${(p) => (p.$noText ? '20px' : '10px')};
    p {
      display: block;
    }
  }
`;
